// src/services/queryString.js

const isPlainObject = (v) => Object.prototype.toString.call(v) === "[object Object]";

/**
 * Builds a query string from an object, skipping undefined/null/"".
 * - Plain objects + arrays => JSON.stringified (useful for last_key cursor objects)
 * - Date => ISO
 * - Booleans/numbers => stringified
 */
export const buildQueryString = (params = {}) => {
  if (!params || typeof params !== "object") return "";

  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => {
      let val = v;

      if (val instanceof Date) {
        val = val.toISOString();
      } else if (Array.isArray(val) || isPlainObject(val)) {
        val = JSON.stringify(val);
      }

      return `${encodeURIComponent(k)}=${encodeURIComponent(String(val))}`;
    });

  return parts.length ? `?${parts.join("&")}` : "";
};
